import { InMemoryCache } from "@apollo/client";
import { relayStylePagination } from "@apollo/client/utilities";
import { applicationProgressVar } from "../applicationProgressVar";
import useFreeze from "../../components/utilities/useFreeze";
import possibleTypes from "./possibleTypes";
import { lastActiveInvestingEntityVar } from "../lastActiveInvestingEntityVar";

const createInMemoryCache = () =>
	new InMemoryCache({
		possibleTypes,
		typePolicies: {
			Account: {
				keyFields: [],
				fields: {
					lastActiveInvestingEntityId: {
						read: (_, { readField }) => {
							const id = readField("id");
							const map = lastActiveInvestingEntityVar();

							return map[id] ?? null;
						},
					},
				},
			},
			AssociatedAccount: {
				keyFields: ["id"],
			},
			Holding: {
				keyFields: ["id"],
				fields: {
					searchTransactions: relayStylePagination(),
				},
			},
			InvestingEntity: {
				keyFields: ["id"],
				fields: {
					searchDocuments: relayStylePagination(),
					searchTransactions: relayStylePagination(),
				},
			},
			Session: {
				keyFields: [],
			},
			OfferInvestor: {
				keyFields: false,
			},
			Offer: {
				fields: {
					applicationProgress: {
						read(_, { readField }) {
							const slug = readField("slug");
							if (!slug) {
								return {
									investingEntityId: null,
									completedSteps: [],
									activeStep: null,
									unitCountDecimal: null,
								};
							}
							return (
								applicationProgressVar()[slug] ?? {
									investingEntityId: null,
									completedSteps: [],
									activeStep: null,
									unitCountDecimal: null,
								}
							);
						},
					},
				},
			},
			Portfolio: {
				keyFields: [],
				fields: {
					holdingById: {
						read: (_, { args, toReference }) =>
							toReference({
								__typename: "Holding",
								id: args.id,
							}),
					},
				},
			},
			Query: {
				fields: {
					searchDocuments: relayStylePagination(),
					searchTransactions: relayStylePagination(),
				},
			},
			Fund: {
				keyFields: false,
			},
		},
	});

const useInMemoryCache = () => {
	const cache = useFreeze(createInMemoryCache);

	return cache;
};

export default useInMemoryCache;
